export const SERVICE = 'AUTH'

export const REFRESH_MARGIN_SECONDS = 480000 // 8 minutes
